import { Box, Stack, ThemeProvider, createTheme } from "@mui/material";
import React, { useState } from "react";
import NavBar from "../main/navbar/Navbar";
import Dashboard from "../main/dashboard/Dashboard";
import RightBar from "../main/rightbar/RightBar";
import AddTooltip from "../main/addTooltip/AddTooltip";
import PPNavigation from "../main/ppNavigation/PPNavigation";

const SaltexUsers = () => {
    const [mode, setMode] = useState("light");
    const darkTheme = createTheme({
      palette:{
        mode: mode
      }
    });
    return (
      <ThemeProvider theme={darkTheme}>
      <Box>
        <NavBar />
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <PPNavigation />
          <Dashboard />
          <RightBar />
        </Stack>
        {/* <AddTooltip /> */}
      </Box>
      </ThemeProvider>
    );
}

export default SaltexUsers;